import type { ComponentProps } from 'react'
import React from 'react'
import type PriceRowPrice from './PriceRowPrice'
import TextLoadingBox from '../Typography/TextLoadingBox'

interface Props extends Pick<ComponentProps<typeof PriceRowPrice>, 'size'> {
  /**
   * Whether or not to include a sale unit loader
   * @default true
   */
  saleUnit?: boolean
}

const SIZES_HEADING_VARIANTS: Record<Props['size'], ComponentProps<typeof TextLoadingBox>['typography']> = {
  S: 'heading6',
  M: 'heading5',
  L: 'heading4',
}

function PriceRowPriceLoadingSkeleton(props: Props) {
  const { size, saleUnit = true } = props

  return <div>
    <TextLoadingBox typography={SIZES_HEADING_VARIANTS[size]} width="5ch" inline />
    {saleUnit && <TextLoadingBox typography="caption-medium" width="5ch" inline />}
  </div>
}

export default PriceRowPriceLoadingSkeleton
